<div class="modal-header">
    <span *ngIf="!positionId" class="modal-header-title">{{ 'EMPLOEE.ADD_POSITIONS' | translate }}</span>
    <span *ngIf="positionId"  class="modal-header-title">{{ 'EMPLOEE.EDIT_POSITIONS' | translate }}</span>
    <div class="tool">
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
            <span aria-hidden="true">&times;</span>
        </button>
   </div>
</div>
<div class="modal-body">

    <form class="form" [formGroup]="form" autocomplete="off">

        <div class="row">


            <div class="col-12">
                <ff-input-lang
                    label="{{ 'EMPLOEE.JOB_TITLE' | translate }}"
                    hint="{{ 'EMPLOEE.JOB_TITLE_IN_ALL_LANGUAGE' | translate }}"
                    fieldId="name"
                    fieldName="name"
                    fieldType="text"
                    [clearField]="ffInputLangParams.name.clearField"
                    [required]="ffInputLangParams.name.required"
                    [inputValue]="positionName" 
                    (changeValue)="eventFnFF('name', $event.name)">
                </ff-input-lang>
            </div>

            <div class="col-12">
                <div class="form-group checkbox">
                    <input class="form-check-input" type="checkbox" formControlName="managerial">
                    <label class="form-check-label"> {{ 'EMPLOEE.IS_A_LEADING_POSITION' | translate }}?</label>
                </div>
            </div>

        </div>

    </form>

</div>
<div class="modal-footer btn-box">
    <button *ngIf="!positionId" type="button" class="btn btn-primary btn-sm" (click)="onCreate()"     [disabled]="form.invalid">{{ 'SAVE'| translate}}</button>
    <button *ngIf="positionId"  type="button" class="btn btn-primary btn-sm" (click)="onUpdate()"     [disabled]="form.invalid">{{ 'SAVE'| translate}}</button>
    <button type="button" class="btn btn-light btn-sm"   (click)="activeModal.dismiss(false)">{{ 'CLOSE' | translate}}</button>
</div>